import { useCallback, useState } from 'react'

export const readSessionStorage = <T>(key: string, defaultValue: T): T => {
  try {
    const val = sessionStorage.getItem(key)
    return val ? JSON.parse(val) : defaultValue
  } catch (e) {
    return defaultValue
  }
}

export const writeSessionStorage = <T>(key: string, value: T) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value))
  } catch (e) {}
}

export const useSessionStorage = <T>(key: string, defaultData: T): [T, (value: T) => any] => {
  const [data, setData] = useState<T>(() => readSessionStorage(key, defaultData))

  const updateData = useCallback(
    (value: T) => {
      setData(value)
      writeSessionStorage(key, value)
    },
    [key]
  )

  return [data, updateData]
}
